import { type ReactNode } from 'react'
import { Stack } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TCard } from '@components'
import { ToggleRow } from './ToggleRow'
import { CompanyGalleryUpload } from './CompanyGalleryUpload'
import { type CompanyCardFormProps } from './CompanyCardFields'

export const OurWorkFields = ({ form }: CompanyCardFormProps): ReactNode => {
  const { t } = useTranslation()
  const showGallerySettings = form.values.sections?.gallery ?? true

  return (
    <TCard>
      <Stack gap='lg'>
        <TCard.Header>
          <TCard.Title>{t('Our work')}</TCard.Title>
        </TCard.Header>
        <ToggleRow
          checked={showGallerySettings}
          description={t('A photo strip of approved work and team images.')}
          label={t('“Our work” gallery')}
          onChange={(checked) => form.setFieldValue('sections.gallery', checked)}
        />
        {showGallerySettings && <CompanyGalleryUpload form={form} />}
      </Stack>
    </TCard>
  )
}
